<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance' }">Finance</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ name: 'Facility Finance deposits'}">
            {{ $root.getHeader() }} Finance Deposits
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-card shadow="never">
      <template slot="header">
        <el-date-picker
          v-model="date"
          type="month"
          placeholder="Pick a month"
          @change="getSecurityDeposits"
        >
        </el-date-picker>
      </template>
      <el-row :gutter="20">
        <el-col :span="currentMonthAndYear ? 24 : 12">
          <el-card
              :body-style="{background: 'linear-gradient(35deg, #009aca, #0c3da7)', padding: '20px' }"
              v-loading="loading"
            >
            <div slot="header">
              <h4 class="head">Collected Deposits</h4>
            </div>
            <div>
              <h4 class="body">
                {{ totalSecurityDeposit }}
              </h4>
            </div>
          </el-card>
        </el-col>
        <el-col v-show="!currentMonthAndYear" :span="12">
          <el-card
              :body-style="{background: 'linear-gradient(35deg, #009aca, #0c3da7)', padding: '20px' }"
              v-loading="loading"
            >
            <div slot="header">
              <h4 class="head">Released Deposits</h4>
            </div>
            <div>
              <h4 class="body">
                {{ totalRefundedDeposit }}
              </h4>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <br />
      <el-row type="flex" :gutter="20">
        <el-col :span="currentMonthAndYear ? 24 : 12">
          <el-card shadow="never" v-loading="loading">
            <template slot="header">
              Collected Deposits
            </template>
            <el-table :data="paidItems" @row-click="routeToCustomer">
              <el-table-column label="Billed On">
                <template slot-scope="scope">
                  {{ scope.row.depositPaidAt | formatDate }}
                </template>
              </el-table-column>
              <el-table-column
                prop="depositPaid"
                label="Amount"
                :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
              >
              </el-table-column>
              <el-table-column prop="customerId.company" label="Customer"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col v-show="!currentMonthAndYear" :span="12">
          <el-card shadow="never" v-loading="loading">
            <template slot="header">
              Released Deposits
            </template>
            <el-table :data="refundItems" @row-click="routeToCustomer">
              <el-table-column label="Liquidated On">
                <template slot-scope="scope">
                  {{ scope.row.depositRefundedAt | formatDate }}
                </template>
              </el-table-column>
              <el-table-column
                prop="depositToBeRefunded"
                label="Amount"
                :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
              >
              </el-table-column>
              <el-table-column prop="customerId.company" label="Customer"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </el-card>
</template>

<script>
import axios from 'axios';
import { LEASING_API } from '../env';

export default {
  name: 'FinanceDeposits',
  props: {
    facility: { type: String, required: true },
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getSecurityDeposits();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getSecurityDeposits();
    this.loading = false;
  },
  computed: {
    currentMonthAndYear() {
      const today = new Date();
      const currentMonth = today.getMonth() === this.date.getMonth();
      const currentYear = today.getFullYear() === this.date.getFullYear();
      return currentMonth && currentYear;
    },
    totalSecurityDeposit() {
      const totalSecurityDeposit = this.paidItems.length > 0 ? this.paidItems
        .map(account => account.depositPaid)
        .reduce((val1, val2) => Number(val1) + Number(val2), 0) : 0;
      return this.$options.filters.currencySign(Number(totalSecurityDeposit), this.$root.state.facilityData);
    },
    totalRefundedDeposit() {
      const refundedAmount = this.refundItems.length > 0 ? this.refundItems
        .map(account => account.depositToBeRefunded)
        .reduce((val1, val2) => Number(val1) + Number(val2), 0) : 0;
      return this.$options.filters.currencySign(Number(refundedAmount), this.$root.state.facilityData);
    },
  },
  data() {
    return {
      facilityData: null,
      loading: true,
      date: new Date(),
      paidItems: [],
      refundItems: [],
    };
  },
  methods: {
    async getSecurityDeposits() {
      this.loading = true;
      const response = await axios.get(`${LEASING_API}/v1/finance/facility/${this.facility}`, {
        params: {
          ...(this.date ? {
            month: this.date.getMonth(),
            year: this.date.getFullYear(),
          } : {}),
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.paidItems = response.data.paid;
      this.refundItems = response.data.refunded;
      this.loading = false;
    },
    routeToCustomer(row) {
      if (this.facility) {
        this.$router.push({ name: 'Facility Customer', params: { id: row.customerId._id, facility: this.facility } });
        return;
      }
      this.$router.push({ name: 'Customer', params: { id: row.customerId._id } });
    },
  },
};
</script>

<style scoped>
.body {
  color: #efefef;
  font-weight: 300;
}

.head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}
</style>



// WEBPACK FOOTER //
// src/components/FinanceDeposits.vue